import React from 'react';
import { Repass } from 'components/Login';

export default (props) => <Repass {...props} />;
